import { combineReducers } from 'redux';

import customersSlice from './customersSlice';
import authSlice from './authSlice';
import docTypesSlice from './docTypesSlice';
import messagesSlice from './messagesSlice';
import preferencesSlice from './preferencesSlice';
import locationsSlice from './locationsSlice';
import userSlice from './userSlice';
import selectivitySlice from './selectivitySlice';
import reportsSlice from './reportsSlice';
import landingSlice from './landingSlice';

const appReducer = combineReducers({
  auth: authSlice,
  preferences: preferencesSlice,
  customers: customersSlice,
  docTypes: docTypesSlice,
  messages: messagesSlice,
  locations: locationsSlice,
  users: userSlice,
  selectivity: selectivitySlice,
  reports: reportsSlice,
  landing: landingSlice,
});

const rootReducer: typeof appReducer = (state, action) => {
  if (action.type === 'auth/signOut/fulfilled') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
